import * as React from "react";

import { InstrumentSetupGate } from "../../../../components/Instruments/InstrumentSetupGate";
import { ExecutionRulesSimulatorPanel } from "../../ExecutionRulesSimulator";
import type { WorkspaceCreateContext } from "../../../../types/workspace";

export type WorkspaceSimulationDrawerContentProps = {
  backtestId: string;
  brokerAccountCode: string;
  /** Strategy upstream of this simulation on the canvas (enables Save as policy version). */
  prefillStrategyId?: string | null;
  workspacePolicyContext?: WorkspaceCreateContext;
  onStrategyVersionSaved?: (backtestId?: string) => void | Promise<void>;
  onSimulationUpdated?: () => void | Promise<void>;
  onDeleted?: () => void;
  onClose?: () => void;
};

export function WorkspaceSimulationDrawerContent({
  backtestId,
  brokerAccountCode,
  prefillStrategyId,
  workspacePolicyContext,
  onStrategyVersionSaved,
  onSimulationUpdated,
  onDeleted,
  onClose,
}: WorkspaceSimulationDrawerContentProps): React.ReactElement {
  return (
    <div data-workspace-simulation-drawer="" className="flex min-h-full min-w-0 flex-1 flex-col">
      <InstrumentSetupGate featureLabel="Simulator">
        <div className="flex min-h-full min-w-0 flex-1 flex-col">
          <ExecutionRulesSimulatorPanel
            variant="standalone"
            layout="embedded"
            resultsOnlyLayout
            initialBacktestId={backtestId}
            lockedBrokerAccountCode={brokerAccountCode}
            hideSavedBacktestsButton
            prefillStrategyId={prefillStrategyId ?? null}
            workspacePolicyContext={workspacePolicyContext}
            onStrategyVersionSaved={onStrategyVersionSaved}
            onBacktestSaved={() => {
              void onSimulationUpdated?.();
            }}
            onDeleted={onDeleted}
            onClose={onClose}
          />
        </div>
      </InstrumentSetupGate>
    </div>
  );
}
